import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

/** Wraps a switch that belongs to the switch above it, and draws the elbow that says so. */
export const BulkRebuildSubOptionStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-rebuild-sub-option",
})`
  position: relative;
  padding-inline-start: 24px;

  /* Logical borders and offsets throughout, so the elbow mirrors itself in Hebrew rather than
     reaching away from the option it hangs off. Its height puts the corner on the switch's centre. */
  &::before {
    content: "";
    position: absolute;
    inset-inline-start: 8px;
    top: 0;
    width: 22px;
    height: 19px;
    border-inline-start: 1px solid ${greyMui._400};
    border-bottom: 1px solid ${greyMui._400};
    border-end-start-radius: 4px;
  }

  /* The indent is the padding alone: MUI pulls the label 11px back, which would slide the switch
     out from under the elbow and, being a physical margin, by different amounts per direction. */
  .MuiFormControlLabel-root {
    margin-inline-start: 0;
  }
`;
